/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
import { useEffect, useState } from 'react';
import type {
  Asset,
  ContentfulClientApi,
  CreateClientParams,
  Entry,
} from 'contentful';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { getEnvVars } from '@order/utils';

const {
  CONTENTFUL_SWEETGREEN_SPACE_ID,
  CONTENTFUL_CONTENT_DELIVERY_API_ACCESS_TOKEN,
} = getEnvVars();

export const DEFAULT_CREATE_CONTENTFUL_CLIENT_PARAMS: CreateClientParams = {
  space: CONTENTFUL_SWEETGREEN_SPACE_ID,
  accessToken: CONTENTFUL_CONTENT_DELIVERY_API_ACCESS_TOKEN,
};

const createClient = () => {
  /**
   * Normally we would import this with:
   *
   * ```
   * import { createClient } from 'contentful';
   * ```
   *
   * However, this was causing crashes in the iOS Simulator
   * and it was suggested that we do the following:
   */
  return require('contentful/dist/contentful.browser.min.js').createClient(
    DEFAULT_CREATE_CONTENTFUL_CLIENT_PARAMS,
  );
};

export const useContentfulClient = () => {
  const isContentfulEnabled = useFeatureFlag('OPS-contentful-enabled');

  // create contentful client instance based on feature flag

  const [contentfulClient, setContentfulClient] = useState<
    ContentfulClientApi | undefined
  >(isContentfulEnabled ? createClient() : undefined);

  useEffect(() => {
    if (!isContentfulEnabled || typeof contentfulClient !== 'undefined') return;

    setContentfulClient(createClient());
  }, [contentfulClient, isContentfulEnabled]);

  return isContentfulEnabled ? contentfulClient : undefined;
};

export type ContentfulAsset = Asset;
export type ContentfulEntry<T> = Entry<T>;
